var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUntick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(6985 -5354)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(-6984 5355)",
    fill: "none",
    stroke: "#cccccc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "checked",
    d: "M0,73.426,7.56,81,22.077,66.5l-2.084-2.055L7.56,76.862l-5.5-5.5Z",
    transform: "translate(-6974 5303.557)",
    fill: "#cccccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntick);
export default __webpack_public_path__ + "static/media/untick.fd8f12ef1d65d0e927f4f581a4117fae.svg";
export { ForwardRef as ReactComponent };